import React from 'react';

const LoadingScreen = ({ message = "Initializing secure connection..." }) => {
  return (
    <div className="fixed inset-0 bg-black z-50 flex items-center justify-center overflow-hidden">
      {/* Cyberpunk Grid Background */}
      <div className="absolute inset-0 opacity-20">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(cyan 1px, transparent 1px),
              linear-gradient(90deg, cyan 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      {/* Floating Neon Particles */}
      <div className="absolute inset-0 pointer-events-none">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-cyan-400 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              boxShadow: '0 0 10px #00ffff'
            }}
          />
        ))}
        {[...Array(8)].map((_, i) => (
          <div
            key={`pink-${i}`}
            className="absolute w-1 h-1 bg-pink-500 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              boxShadow: '0 0 8px #ff1493'
            }}
          />
        ))}
      </div>

      {/* Holographic Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-br from-pink-400/20 to-purple-600/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Main Loading Content */}
      <div className="relative z-10 text-center">
        {/* Spinner Container */}
        <div className="relative mb-8 mx-auto w-32 h-32">
          {/* Outer Ring */}
          <div 
            className="absolute inset-0 w-32 h-32 border-4 border-cyan-400/30 rounded-full"
            style={{
              animation: 'spin 3s linear infinite'
            }}
          ></div>
          
          {/* Middle Ring */}
          <div 
            className="absolute inset-0 w-32 h-32 border-4 border-transparent border-t-cyan-400 rounded-full"
            style={{
              animation: 'spin 1.5s linear infinite'
            }}
          ></div>
          
          {/* Inner Ring */}
          <div 
            className="absolute inset-2 w-28 h-28 border-2 border-pink-500/30 rounded-full"
            style={{
              animation: 'spin 2s linear infinite reverse'
            }}
          ></div>
          
          {/* Center Core */}
          <div className="absolute inset-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <div 
              className="w-8 h-8 bg-gradient-to-br from-cyan-400 to-pink-500 rounded-full animate-pulse"
              style={{ 
                boxShadow: '0 0 20px #00ffff, 0 0 40px #ff1493' 
              }}
            />
          </div>
        </div>

        {/* Loading Text */}
        <div className="space-y-4">
          <h2 className="text-2xl font-black font-mono">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-500 to-purple-500">
              SYSTEM LOADING
            </span>
          </h2>
          
          <p className="text-gray-400 font-mono text-sm flex items-center justify-center gap-2">
            {'>'} {message}
            <span className="animate-pulse text-green-400">█</span>
          </p>

          {/* Progress Dots */}
          <div className="flex justify-center gap-2 mt-6">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 bg-cyan-400 rounded-full animate-bounce"
                style={{
                  animationDelay: `${i * 0.2}s`,
                  boxShadow: '0 0 8px #00ffff'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen; 